import { request } from './client';

export type EventGroupStatus = 'PENDING' | 'PLAYING' | 'FINISHED';

export interface EventGroup {
  eventGroupId: string;
  name: string;
  sportLeague: string;
  seasonYear: number;
  startDate: string | Date | null;
  endDate: string | Date | null;
  status?: EventGroupStatus;
}

export const getEventGroupsBySportLeague = (sportLeague: string) =>
  request<EventGroup[]>(`/event-groups/${sportLeague}`);

export const getEventGroupsBySportLeagueWithDates = (sportLeague: string) =>
  request<EventGroup[]>(`/event-groups/${sportLeague}/with-dates`);

export const getEventGroupById = (id: string) =>
  request<EventGroup>(`/event-groups/group/${id}`);

export const getEventGroupByIdWithDates = (id: string) =>
  request<EventGroup>(`/event-groups/group/${id}/with-dates`);

export const createEventGroup = (body: { name: string; sportLeague: string }) =>
  request<EventGroup>('/event-groups', { method: 'POST', body });
